import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f565f73"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-w-full fileUploader tw-h-[88px]"
}
const _hoisted_3 = ["data-cy"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-flex tw-w-[43px] tw-h-[43px] tw-justify-center tw-items-center tw-pl-[7.984px] tw-pr-[7.987px] tw-pt-[9.828px] tw-pb-[9.962px] tw-rounded-[307.143px] uploadIconWrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/upload_icon.svg",
    alt: "upload",
    class: "tw-invert-[82%] tw-sepia-[0%] tw-saturate-[1%] tw-hue-rotate-[232deg] tw-brightness-[91%] tw-contrast-[91%] tw-w-[27.029px] tw-h-[23.21px] uploadIcon"
  })
], -1))
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[2px] info" }
const _hoisted_6 = {
  "data-cy": "file-uploader-button",
  class: "tw-text-[#387dff] tw-underline clickUploadText"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "tw-text-[#b7b7b7] tw-text-center tw-text-[11px] tw-not-italic tw-font-normal tw-leading-[135%] formats" }
const _hoisted_9 = {
  key: 2,
  class: "tw-flex tw-w-full tw-justify-center preview"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["data-cy"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uploadLoadingButton = _resolveComponent("uploadLoadingButton")!
  const _component_ImageCropper = _resolveComponent("ImageCropper")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.idWrap,
    class: "tw-flex tw-flex-1 tw-max-w-[519.541px] tw-items-start tw-gap-2.5 tw-border tw-px-5 tw-py-[25px] tw-rounded-md tw-border-solid tw-border-[#eff0f1] tw-relative fileUploaderWrapper",
    "data-cy": "add-evidence-modal-click-to-upload-btn"
  }, [
    (_ctx.onLoading === _ctx.API_STATUS_LOADING.LOADING)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_uploadLoadingButton)
        ]))
      : (
        _ctx.imgSrc === null ||
        _ctx.onLoading === _ctx.API_STATUS_LOADING.ERROR ||
        _ctx.onLoading === _ctx.API_STATUS_LOADING.NO_ACTION ||
        _ctx.isMultiple
      )
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "tw-cursor-[pointer] tw-flex tw-flex-col tw-items-center tw-gap-2.5 tw-w-full fileUploader",
            "data-cy": `img-detail-image-${_ctx.type}`,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickInput && _ctx.clickInput(...args))),
            onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)))
          }, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", {
                class: _normalizeClass(`tw-text-[#878787] tw-text-center tw-text-[${_ctx.fontSizeTitle}px] tw-not-italic tw-font-normal tw-leading-[135%] text`)
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getUiText("app-component-file-upload-select-title-a-1")), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.getUiText("app-component-file-upload-select-title-b-1")), 1)
              ], 2),
              _createElementVNode("input", {
                id: _ctx.idInput,
                ref: "fileInput",
                class: "tw-invisible tw-w-0 tw-h-0",
                type: "file",
                onChange: _cache[0] || (_cache[0] = (e) => _ctx.handleFileSelect(e.target.files[0]))
              }, null, 40, _hoisted_7),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.guidance), 1)
            ])
          ], 40, _hoisted_3))
        : (_ctx.onLoading === _ctx.API_STATUS_LOADING.SUCCESS && !_ctx.isMultiple)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                class: _normalizeClass(["tw-h-[88px]", _ctx.useRectangleStencil ? '' : 'tw-w-[88px] tw-rounded-[50%]']),
                src: _ctx.croppedImage,
                alt: "image"
              }, null, 10, _hoisted_10),
              _createElementVNode("span", {
                class: "tw-cursor-pointer tw-absolute tw-right-[10px] tw-top-[10px] tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-gap-[7.143px] tw-bg-[#878787] tw-px-[5.714px] tw-py-[1.429px] tw-rounded-[50%]",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
              }, [
                _createElementVNode("img", {
                  class: "tw-w-[8.571px] tw-h-[8.572px]",
                  src: "/img/close_icon_white.svg",
                  "data-cy": `img-detail-close-icon-${_ctx.type}`,
                  alt: "close"
                }, null, 8, _hoisted_11)
              ])
            ]))
          : _createCommentVNode("", true),
    _createVNode(_component_ImageCropper, {
      visible: _ctx.isImageCropperVisible,
      src: _ctx.imgSrcString,
      "src-type": _ctx.imgSrc?.type,
      title: _ctx.cropModalTitle,
      formats: _ctx.cropFormats,
      recommendations: 
        _ctx.getUiText('app-settings-organisation-profile-avatar-cropper-formats-2')
      ,
      "is-small-screen": _ctx.isSmallScreen,
      rounded: _ctx.rounded,
      "use-rectangle-stencil": _ctx.useRectangleStencil,
      onCroppedImg: _cache[5] || (_cache[5] = (blob) => _ctx.emitFile(blob)),
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitFile(null)))
    }, null, 8, ["visible", "src", "src-type", "title", "formats", "recommendations", "is-small-screen", "rounded", "use-rectangle-stencil"])
  ], 8, _hoisted_1))
}